import { Card, Container } from "@mui/material";
import styled from "styled-components";

const MainContent = styled(Card)`
    min-height: 100vh;
    padding: 1rem;
`;

export { MainContent };
